export default __webpack_public_path__ + "static/media/twig.18a30117.jpg";